// extracted by mini-css-extract-plugin
export var box = "search-pages-module--box--eff6a";
export var container = "search-pages-module--container--27faa";
export var highlight = "search-pages-module--highlight--35ef9";
export var snippet = "search-pages-module--snippet--aa81c";